import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { setDropDownArray } from '../../../redux/dropdownSlice';
import { genreList, eventTypeList } from '../../../services/api';


export default ()=> {
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const dispatch = useDispatch();
    //Get approver dropdown array from Server
    // const [genre, setgenre] = useState(dropdownReducer.genre);
    const [eventType, setEventType] = useState(dropdownReducer.event_type)

 
     const { data: eventTypeData, isLoading: eventTypeLoading, refetch: refetchEventType } = useQuery( ["eventType"],
                                            () => eventTypeList(),
                                            { enabled: (dropdownReducer.event_type?.length == 0 || dropdownReducer.event_type_filter?.length == 0 ), retry: false }
                                         )                                            

    useEffect(() => {
        const apiEventTypes = eventTypeData?.data?.event_types;
        // Only overwrite the list when the API actually returned types.
        // Right after login the request can fire before auth is ready and
        // resolve empty (retry:false); overwriting here would wipe the
        // hardcoded EVENT_TYPES fallback and collapse the filter to "All Types".
        if (apiEventTypes?.length > 0) {
            var temArr = apiEventTypes.map((type)=> {
                return {...type, checked: false}
            })
            temArr.unshift({id:0,  value:"View-All", checked:true})
           dispatch(setDropDownArray({event_type: apiEventTypes, event_type_filter: temArr }))
        }
    }, [eventTypeData])


    const selectedEventType = (id) => {
        if (dropdownReducer.event_type.length > 0 && dropdownReducer.event_type.find((item)=> item.id == id) ) {
            return dropdownReducer.event_type.find((item)=> item.id == id)
        } else {
            return {}
        }
    };
  
    return [dropdownReducer.event_type, selectedEventType]  
}